import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
import { formatARS } from '../utils/currency';
export function FinalCta() {
  return <section aria-labelledby="cierre-titulo" className="w-full border-t border-line bg-panel py-20 sm:py-28" data-id="element-33" data-mp="19g0cphlqnujw">
      <div className="mx-auto max-w-5xl px-4" data-id="element-34" data-mp="15ckkcxgpcgd0">
        <h2 id="cierre-titulo" className="font-display text-4xl font-extrabold uppercase tracking-tight text-bone sm:text-5xl" data-id="element-35" data-mp="1jd517o32423v">
          Tenés dos caminos ahora
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-36" data-mp="1t2omf0e8s81w">
          <div className="flex flex-col rounded-lg border border-line bg-ink/60 p-7" data-id="element-37" data-mp="1t253bgcuvdma">
            <div className="flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-mute" data-id="element-38" data-mp="1o56dvb44zuuf">
              <XIcon aria-hidden="true" className="h-4 w-4 text-clay" data-id="element-39" data-mp="2245ze9wcrtmd" />
              Camino 1
            </div>
            <p className="mt-4 text-lg leading-relaxed text-mute" data-id="element-40" data-mp="1x6cv5mem19oq">
              Seguir improvisando cada clase, arriesgando las rodillas de tus alumnos y perdiéndolos carrera tras carrera.
            </p>
          </div>

          <div className="flex flex-col rounded-lg border border-lime/50 bg-ink p-7" data-id="element-41" data-mp="s6iir45nayiw">
            <div className="flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-lime" data-id="element-42" data-mp="x5v8bwnwijp6">
              <CheckIcon aria-hidden="true" className="h-4 w-4" data-id="element-43" data-mp="120sdutlz2axb" />
              Camino 2
            </div>
            <p className="mt-4 text-lg leading-relaxed text-bone/90" data-id="element-44" data-mp="162ma8pp4wsro">
              Invertir lo que cuestan dos pizzas en un sistema probado que te va a convertir en el profe de trail que todos quieren entrenar.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center text-center" data-id="element-45" data-mp="1ks1nr3znn1pf">
          <CtaButton className="max-w-2xl" data-id="element-46" data-mp="1pszew62n7632">
            Sí, quiero cambiar mi forma de enseñar — acceso inmediato por {formatARS(offer.price)}
          </CtaButton>
          <p className="mt-4 text-sm text-mute" data-id="element-47" data-mp="1troqbt44edk2">
            Pago único de {formatARS(offer.price)} · Garantía de {offer.guaranteeDays} días · Acceso de por vida
          </p>
        </div>
      </div>
    </section>;
}